/* Parbiart Mix — a főoldali saját szekciók viselkedése.
   1. Kérdéssor (sections/pb-kerdesek.liquid): a szóra kattintva alatta nyílik a válasz.
   2. Guruló bögre (sections/pb-hirlevel.liquid): görgetéskor a lap szélén gurul a hírlevélig.
   A témaszerkesztő újratölti a szekciót (shopify:section:load) — ezért minden init ismételhető. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. kérdéssor ---- */
  function initKerdesek(root) {
    if (!root || root.dataset.pbInit) return;
    root.dataset.pbInit = '1';
    var btns = Array.prototype.slice.call(root.querySelectorAll('.pb-spk[aria-controls]'));

    function panelOf(b) { return document.getElementById(b.getAttribute('aria-controls')); }

    function closeAll() {
      btns.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var p = panelOf(b);
        if (p) p.hidden = true;
      });
    }

    // a buborék csücske a megnyomott szó alá mutasson
    function aim(b, p) {
      var br = b.getBoundingClientRect(), pr = p.getBoundingClientRect();
      var tip = Math.max(24, Math.min(pr.width - 24, br.left + br.width / 2 - pr.left));
      p.style.setProperty('--tip', tip + 'px');
    }

    function open(b, focus) {
      var p = panelOf(b);
      if (!p) return;
      closeAll();
      b.setAttribute('aria-expanded', 'true');
      p.hidden = false;
      aim(b, p);
      if (focus) {
        var f = p.querySelector('textarea, input:not([type=hidden])');
        if (f) f.focus({ preventScroll: true });
      }
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-expanded') === 'true') { closeAll(); b.focus(); return; }
        open(b, b.classList.contains('pb-spk--ask'));
      });
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var cur = btns.filter(function (b) { return b.getAttribute('aria-expanded') === 'true'; })[0];
      if (cur) { closeAll(); cur.focus(); }
    });

    window.addEventListener('resize', function () {
      btns.forEach(function (b) {
        var p = panelOf(b);
        if (p && !p.hidden) aim(b, p);
      });
    });

    // elküldött űrlap után (siker vagy hiba) a „Kérdezz" buborék nyitva marad
    btns.forEach(function (b) {
      var p = panelOf(b);
      if (p && p.querySelector('[data-pb-open]')) {
        open(b, false);
        p.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      }
    });
  }

  /* ---- 2. guruló bögre ---- */
  /* Gurulás közben a bögre a képernyőhöz van rögzítve (position: fixed), és görgetésre csak forog —
     így a helyét a böngésző tartja, nem a szkript tologatja képkockánként (az akadozott, ügyfél 10-12).
     A méretek (honnan indul, hová érkezik) egyszer vannak lemérve, és csak akkor újra, ha a lap
     mérete változik; görgetés közben a szkript nem mér. */
  var mug = null, geo = null, mugFix = null, mugTick = false, mugMeres = false, mugRO = null;

  function mugMeasure() {
    mugMeres = false;
    geo = null;
    mug = document.querySelector('.pb-rollmug');
    var land = document.querySelector('.pb-landing');
    if (reduce || !mug || !land) return;
    // alapállapot: a lapba ültetve, eltolás nélkül
    mug.classList.remove('pb-rollmug--fix');
    mug.style.left = mug.style.right = mug.style.top = mug.style.transform = '';
    mugFix = null;
    var par = mug.offsetParent;
    if (!par) return;   // 750 px alatt (mobilon) nincs guruló bögre
    var ref = par.getBoundingClientRect();
    // indulás: az első szekció, ami data-pb-mug-start jelölést kapott (a kérdéssor), különben 600 px
    var start = document.querySelector('[data-pb-mug-start]');
    var st = start ? start.getBoundingClientRect().top - ref.top : 600;
    mug.style.setProperty('--pb-mugtop', st + 'px');
    var lr = land.getBoundingClientRect();
    geo = {
      top: ref.top + window.pageYOffset,   // a viszonyítási elem teteje a lapon
      left: ref.left,
      bx: mug.offsetLeft, by: mug.offsetTop,
      tx: lr.left - ref.left, ty: lr.top - ref.top
    };
  }

  function mugRun() {
    mugTick = false;
    if (mugMeres) mugMeasure();
    if (!geo || !mug) return;
    var vh = window.innerHeight || 800;
    var dy = geo.ty - geo.by;
    var p = (vh * 0.45 - (geo.top - window.pageYOffset) - geo.by) / Math.max(1, dy);
    p = p < 0 ? 0 : p > 1 ? 1 : p;
    var q = p > 0.85 ? (p - 0.85) / 0.15 : 0;   // az utolsó szakaszon oldalra is gurul, a helyére
    var fix = p > 0 && p < 1;
    if (fix !== mugFix) {
      mugFix = fix;
      mug.classList.toggle('pb-rollmug--fix', fix);
      mug.style.left = fix ? (geo.left + geo.bx) + 'px' : '';
      mug.style.right = fix ? 'auto' : '';
      mug.style.top = fix ? (vh * 0.45) + 'px' : '';
    }
    mug.style.transform = 'translate(' + (q * (geo.tx - geo.bx)).toFixed(1) + 'px,' + (fix ? 0 : p * dy).toFixed(1) + 'px) rotate(' + (p * 1080).toFixed(1) + 'deg)';
    mug.dataset.landed = p >= 1 ? '1' : '';
  }
  function mugFx() { if (!mugTick) { mugTick = true; requestAnimationFrame(mugRun); } }
  function mugUjra() { mugMeres = true; mugFx(); }

  function initMug() {
    var m = document.querySelector('.pb-rollmug');
    if (!m) return;
    if (!m.dataset.pbInit) {
      m.dataset.pbInit = '1';
      m.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      });
    }
    // ha a lap magassága változik (későn betöltődő kép, nyíló válasz), az érkezési hely is máshol lesz
    if (window.ResizeObserver && m.offsetParent) {
      if (mugRO) mugRO.disconnect();
      mugRO = new ResizeObserver(mugUjra);
      mugRO.observe(m.offsetParent);
    }
    mugUjra();
  }
  window.addEventListener('scroll', mugFx, { passive: true });
  window.addEventListener('resize', mugUjra);
  window.addEventListener('load', mugUjra);

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pb-kerdesek]'), initKerdesek);
    initMug();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
